import { AlignItems, Body1, Box, Display } from '@gousto-internal/citrus-react';
import { DietaryFiltersAccordionButton } from './styles';

export const DIETARY_FILTERS_ACCORDION_LABEL = 'accordion-heading';

export function DietaryFiltersAccordionTitle() {
  return (
    <Box display={Display.Flex} alignItems={AlignItems.Center} paddingV={2} gap={2}>
      <Body1 size={2} id={DIETARY_FILTERS_ACCORDION_LABEL}>
        Filter by dietary preferences
      </Body1>

      <DietaryFiltersAccordionButton>Show dietary preference filters</DietaryFiltersAccordionButton>
    </Box>
  );
}
